import { Component } from '@angular/core';

@Component({
    selector: 'hr-master-data-shimmer',
    templateUrl: './hr-master-data-shimmer.component.html',
})
export class HrMasterDataShimmerComponent {
    constructor() {}
}
